import { documentReady } from "@sazka/utils/document-ready";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import { options } from "./options";
import { createCustomGalleryElement } from "./create-custom-gallery-element";

documentReady(() => {
    const imageAnchors = document.querySelectorAll("#pswp-gallery-container a");

    if (!imageAnchors.length) return;
    const lightbox = new PhotoSwipeLightbox(options);

    const setAnchorAttributes = (anchor: Element, img: HTMLImageElement) => {
        anchor.setAttribute("data-pswp-width", img.naturalWidth.toString());
        anchor.setAttribute("data-pswp-height", img.naturalHeight.toString());
    };

    // set correct data-pswp-width and data-pswp-height attributes on anchor tags
    imageAnchors.forEach((anchor) => {
        const img = anchor.querySelector("img");

        if (!img) {
            return;
        }

        if (img.complete && img.naturalWidth > 0 && img.naturalHeight > 0) {
            setAnchorAttributes(anchor, img);
        }

        img.onload = () => {
            setAnchorAttributes(anchor, img);
        };
    });

    // use custom content for lightbox
    lightbox.on("contentLoad", (e) => {
        e.preventDefault();
        const { content } = e;

        if (!content?.data) return;

        const close = () => lightbox.pswp.close();

        const figureElement = createCustomGalleryElement(content.data, close);

        content.element = figureElement as HTMLDivElement;
    });

    lightbox.on("contentAppend", (e) => {
        const { content } = e;
        if (content.pictureElement && !content.pictureElement.parentNode) {
            e.preventDefault();
            content.slide.container.appendChild(content.pictureElement);
        }
    });

    lightbox.on("contentRemove", (e) => {
        const { content } = e;
        if (content?.pictureElement?.parentNode) {
            e.preventDefault();
            content.pictureElement.remove();
        }
    });

    lightbox.init();
});
